/* ==========================================================================
   UiPanelPassengerTrain > Config
   ========================================================================== */

const configuration = {
    type: {
        panel: 'ui-panel-passenger-train'
    },
    css: {
        panel: 'ui-panel--passenger-train'
    }
};

const config = () => configuration;

module.exports = config;
